import { render, staticRenderFns } from "./WithdrawLimitUpdate.vue?vue&type=template&id=2d6e0806&"
import script from "./WithdrawLimitUpdate.vue?vue&type=script&lang=js&"
export * from "./WithdrawLimitUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports